"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _InputBase = _interopRequireDefault(require("@material-ui/core/InputBase"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));

var _ie11Check = require("@jobmatchme/utils/es/ie11Check");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var TextField = function TextField(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? false : _ref$label,
      _ref$helperText = _ref.helperText,
      helperText = _ref$helperText === void 0 ? false : _ref$helperText,
      type = _ref.type,
      placeholder = _ref.placeholder,
      id = _ref.id,
      key = _ref.key,
      name = _ref.name,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      inputRef = _ref.inputRef,
      required = _ref.required,
      fullWidth = _ref.fullWidth,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 1 : _ref$tabIndex,
      value = _ref.value,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$disabledBg = _ref.disabledBg,
      disabledBg = _ref$disabledBg === void 0 ? false : _ref$disabledBg,
      className = _ref.className,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error,
      _ref$lightText = _ref.lightText,
      lightText = _ref$lightText === void 0 ? false : _ref$lightText,
      _ref$darkBG = _ref.darkBG,
      darkBG = _ref$darkBG === void 0 ? false : _ref$darkBG,
      _ref$noBorder = _ref.noBorder,
      noBorder = _ref$noBorder === void 0 ? false : _ref$noBorder,
      _ref$multiline = _ref.multiline,
      multiline = _ref$multiline === void 0 ? false : _ref$multiline,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? 1 : _ref$rows,
      _ref$defaultInput = _ref.defaultInput,
      defaultInput = _ref$defaultInput === void 0 ? false : _ref$defaultInput,
      _ref$startAdornment = _ref.startAdornment,
      startAdornment = _ref$startAdornment === void 0 ? false : _ref$startAdornment,
      _ref$endAdornment = _ref.endAdornment,
      endAdornment = _ref$endAdornment === void 0 ? false : _ref$endAdornment,
      _ref$customSize = _ref.customSize,
      customSize = _ref$customSize === void 0 ? false : _ref$customSize,
      _ref$combinedLeft = _ref.combinedLeft,
      combinedLeft = _ref$combinedLeft === void 0 ? false : _ref$combinedLeft,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? '' : _ref$defaultValue,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      _ref$paddingBottom = _ref.paddingBottom,
      paddingBottom = _ref$paddingBottom === void 0 ? false : _ref$paddingBottom,
      inputProps = _ref.inputProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: _styleModule.default.textField,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "".concat(startAdornment ? _styleModule.default.startAdornment : '', " ").concat(_ie11Check.isIE11 ? _styleModule.default.ie11 : ''),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormControl.default, {
        fullWidth: fullWidth,
        className: "".concat(_styleModule.default.formControl, " ").concat(className ? className : '', " ").concat(defaultInput ? _styleModule.default.default : '', " \n        ").concat(customSize ? _styleModule.default[customSize] : ''),
        error: error,
        children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          id: "".concat(id, "-helper-text"),
          htmlFor: id,
          children: label
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputBase.default, {
          value: value ? value : undefined,
          inputProps: (0, _extends2.default)({
            id: id,
            key: key,
            name: name,
            type: type ? type : 'text',
            required: required,
            tabIndex: tabIndex,
            defaultValue: defaultValue,
            className: "".concat(_styleModule.default.baseInput, " \n            ").concat(disabled ? _styleModule.default.disabled : '', " \n            ").concat(disabledBg ? _styleModule.default.noBg : '', "\n            ").concat(lightText ? _styleModule.default.lightText : '', "\n            ").concat(darkBG ? _styleModule.default.darkBG : '', "\n            ").concat(noBorder ? _styleModule.default.noBorder : '', "\n            ").concat(error ? _styleModule.default.error : '', "\n            ").concat(defaultInput ? _styleModule.default.defaultInput : '', "\n            ").concat(startAdornment ? _styleModule.default.startAdornment : '', " \n            ").concat(customSize ? _styleModule.default[customSize] : '', "\n            ").concat(combinedLeft ? _styleModule.default.combinedLeft : '', "\n            ").concat(paddingBottom ? _styleModule.default.paddingBottom : '')
          }, inputProps),
          startAdornment: startAdornment,
          endAdornment: endAdornment,
          "aria-describedby": "".concat(id, "-helper-text"),
          type: type,
          placeholder: placeholder,
          multiline: multiline,
          fullWidth: fullWidth,
          onChange: onChange,
          onBlur: onBlur,
          disabled: disabled,
          error: error,
          rows: rows,
          inputRef: inputRef,
          autoFocus: autoFocus
        }), helperText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormHelperText.default, {
          className: "".concat(_styleModule.default.helperText),
          id: "".concat(id, "-helper-text"),
          children: helperText
        })]
      })
    })
  });
};

var _default = TextField;
exports.default = _default;